import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'

export const translateTypeFields = (typeField) => {
  if (typeField === 'memberships') {
    return useI18nForVue2().t('message.memberships')
  }
  if (typeField === 'technical-sales') {
    return useI18nForVue2().t('message.technicians')
  }
  if (typeField === 'variant') {
    return 'catalogue'
  }
  if (typeField === 'offer') {
    return 'offres'
  }
  if (typeField === 'address') {
    return 'adresses'
  }
  if (typeField === 'member-segmentation') {
    return 'segmentation'
  }
  if (typeField === 'variant-segment') {
    return 'segmentation variantes'
  }
  if (typeField === 'stocks') {
    return 'stocks'
  }
  if (typeField === 'quota') {
    return 'quotas'
  }
  if (typeField === 'discount-association') {
    return 'associations remise'
  }
  if (typeField === 'customer-contacts') {
    return 'contacts'
  }
  if (typeField === 'recommended_lists') {
    return useI18nForVue2().t('message.recommended-lists')
  }

  return typeField
}
